import { useRef, useState } from "react";
import { Paperclip, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const MAX_BYTES = 5 * 1024 * 1024;
const ALLOWED = /\.(jpe?g|png|webp|xls|xlsx|pdf)$/i;

export const SupportFilePicker = ({ files, onChange, disabled, idPrefix }) => {
  const input = useRef(null);
  const [error, setError] = useState("");

  const choose = event => {
    const incoming = Array.from(event.target.files || []);
    event.target.value = "";
    if (files.length + incoming.length > 5) {
      setError("Massimo 5 allegati per messaggio."); return;
    }
    if (incoming.some(file => file.size > MAX_BYTES || !file.size || !ALLOWED.test(file.name))) {
      setError("Ogni file deve essere JPG, PNG, WebP, XLS, XLSX o PDF e non superare 5 MB."); return;
    }
    setError(""); onChange([...files, ...incoming]);
  };

  return (
    <div className="space-y-2" data-testid={`${idPrefix}-attachments`}>
      <input type="file" accept=".jpg,.jpeg,.png,.webp,.xls,.xlsx,.pdf" multiple ref={input}
             onChange={choose} disabled={disabled} className="sr-only"
             data-testid={`${idPrefix}-file-input`} aria-label="Seleziona allegati" />
      <Button type="button" variant="outline" disabled={disabled} onClick={() => input.current?.click()}
              className="rounded-sm border-[#C9C6BE] gap-2" title="Allega JPG, PNG, WebP, XLS, XLSX o PDF (massimo 5 file da 5 MB)"
              data-testid={`${idPrefix}-add-file`}><Paperclip className="w-4 h-4" />Allega file</Button>
      {error && <p role="alert" className="text-xs text-[#8C3A3A]" data-testid={`${idPrefix}-file-error`}>{error}</p>}
      {files.length > 0 && <ul className="flex flex-wrap gap-2" data-testid={`${idPrefix}-file-list`}>
        {files.map((file, index) => (
          <li key={`${file.name}-${index}`} className="min-w-0 max-w-full border border-[#D5D2C9] bg-white px-3 py-1.5 flex items-center gap-2 text-xs"
              data-testid={`${idPrefix}-selected-file-${index}`}>
            <span className="truncate min-w-0">{file.name}</span>
            <button type="button" onClick={() => onChange(files.filter((_, i) => i !== index))}
                    disabled={disabled} title={`Rimuovi ${file.name}`} aria-label={`Rimuovi ${file.name}`}
                    data-testid={`${idPrefix}-remove-file-${index}`}>
              <X className="w-3.5 h-3.5" />
            </button>
          </li>
        ))}
      </ul>}
    </div>
  );
};